/* eslint-disable class-methods-use-this */
/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Change Course User Role Service
 * @file ChangeCourseUserRoleService.js
 */

import Framework, { BaseService } from '@greenville/framework';
import { AET_STORE_EVENTS } from '../common/Constants';

export default class ChangeCourseUserRoleService extends BaseService {
  constructor() {
    super(AET_STORE_EVENTS.CHANGE_COURSE_USER_ROLE_REQUESTED, 'changeCourseUserRoleStatus');
  }

  handleEvent(eventName, eventData = {}) {
    const {
      payload
    } = eventData;

    return this.getClient('marin').patch('/registrations', payload);
  }

  handleResponse(response, eventData = {}) {
    const data = response?.data || {};

    if (eventData?.sectionId) {
      Framework.getStoreRegistry().getStore('students').fetchAllUsersOfCourse(
        eventData.sectionId,
        eventData.productId
      );
    }

    Framework.getEventManager().publish(AET_STORE_EVENTS.CHANGE_COURSE_USER_ROLE_COMPLETED, data);
  }

  handleError(error) {
    Framework.getEventManager().publish(AET_STORE_EVENTS.CHANGE_COURSE_USER_ROLE_FAILED, error);
  }
}
